// Écran « Mon compte ». Entièrement fonctionnel : il change réellement
// le mot de passe. Aucune maquette avec la mention « sera branché plus
// tard » n'est livrée — c'est l'erreur n°8 de la liste du design system.
//
// Cet écran n'existait pas chez AGC, alors que deux comptes y étaient
// actifs : personne n'avait jamais pu changer son mot de passe.

import { useState } from 'react';
import { Card, CardHead, CardBody } from '../../ui/Card.jsx';
import { TextField } from '../../ui/TextField.jsx';
import Button from '../../ui/Button.jsx';
import { useToast } from '../../ui/Toast.jsx';
import { useSession } from '../../lib/session.jsx';
import { api } from '../../lib/api.js';
import { formatDateTime } from '../../lib/format.js';

export function ComptePage() {
  const { user, logout } = useSession();
  const toast = useToast();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [errors, setErrors] = useState({});
  const [pending, setPending] = useState(false);

  async function onSubmit(event) {
    event.preventDefault();
    if (next !== confirm) {
      setErrors({ confirm: 'Les deux saisies diffèrent.' });
      return;
    }
    setErrors({});
    setPending(true);
    try {
      await api.post('/auth/password', { current_password: current, new_password: next });
      // Le serveur ferme la session : on le dit avant de renvoyer sur
      // l'écran de connexion, plutôt que de laisser l'utilisateur
      // découvrir une déconnexion inexpliquée.
      toast.success('Mot de passe modifié. Reconnectez-vous.');
      await logout();
    } catch (err) {
      // Les erreurs par champ viennent du serveur, qui est le seul à
      // pouvoir dire si le mot de passe actuel est correct.
      setErrors(err.details ?? { _: err.message });
      if (!err.details) toast.error(err.message);
    } finally {
      setPending(false);
    }
  }

  return (
    <>
      <Card>
        <CardHead title="Identité" />
        <CardBody>
          <dl className="grid-2">
            <div>
              <dt className="caps">Nom</dt>
              <dd>{user?.display_name}</dd>
            </div>
            <div>
              <dt className="caps">Identifiant</dt>
              <dd>{user?.username}</dd>
            </div>
            <div>
              <dt className="caps">Rôle</dt>
              <dd>{user?.role === 'admin' ? 'Administrateur' : 'Deviseur'}</dd>
            </div>
            <div>
              <dt className="caps">Dernière connexion</dt>
              <dd>{formatDateTime(user?.last_login_at)}</dd>
            </div>
          </dl>
        </CardBody>
      </Card>

      <Card>
        <CardHead title="Changer le mot de passe" />
        <CardBody>
          <form className="stack" onSubmit={onSubmit}>
            <TextField
              label="Mot de passe actuel"
              type="password"
              autoComplete="current-password"
              required
              value={current}
              error={errors.current_password}
              onChange={(e) => setCurrent(e.target.value)}
            />
            <TextField
              label="Nouveau mot de passe"
              type="password"
              autoComplete="new-password"
              required
              value={next}
              hint="Douze caractères minimum, avec au moins une minuscule, une majuscule et un chiffre."
              error={errors.new_password}
              onChange={(e) => setNext(e.target.value)}
            />
            <TextField
              label="Confirmation"
              type="password"
              autoComplete="new-password"
              required
              value={confirm}
              error={errors.confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
            {errors._ ? (
              <p className="field__error" role="alert">
                {errors._}
              </p>
            ) : null}
            <div className="row row--end">
              <Button type="submit" variant="primary" disabled={pending}>
                {pending ? 'Enregistrement…' : 'Changer le mot de passe'}
              </Button>
            </div>
          </form>
        </CardBody>
      </Card>
    </>
  );
}

export default ComptePage;
